import styled from 'styled-components';
import { spacing, containers } from '@comicrelief/component-library';

const Wrapper = styled.article.attrs({
  'data-test': 'news'
})`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.color('grey_light')};
`;

const Container = styled.div`
  width: 100%;
  max-width: ${containers.large};
  margin: 0 auto;
  padding-bottom: ${spacing('xl')};
`;

const Section = styled.section.attrs({
  'data-test': 'news-list'
})`
  width: 100%;
  display: flex;
  margin-bottom: ${spacing('m')};
  text-align: center;
  flex-wrap: wrap;
`;

const Grid = styled.div`
  display: flex;
  max-width: ${containers.medium};
  width: 100%;
  justify-content: center;
  margin: 0 auto ${spacing('l')};
  padding: 1rem;
  flex-direction: column;

  @media ${({ theme }) => theme.allBreakpoints('M')} {
    padding: 2rem;
  }

  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding: 4rem;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Items = styled.div.attrs({
  'data-test': 'news-item'
})`
  margin: ${spacing('md')} 0;
  width: 100%;
  text-align: left;
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    margin: ${spacing('md')};
    /* 0.5 to fix ie11 bug */
    width: calc(100% / 3 - 2.05rem);
    a > div > div:first-child {
      height: 190px;
    }
  }
`;

export {
  Wrapper, Container, Section, Grid, Items
};
